module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_dadinho.2e8ae079.png";